// extracted by mini-css-extract-plugin
module.exports = {"modal90":"Gallery_modal90__8CLUd","otherImg":"Gallery_otherImg__2YFoB"};